<template>
<div>
<div>
  <v-app id="inspire">
    <v-content>
      <v-container  fluid>
              <div>
                  <v-row>
                       <v-col cols="12" md="12">

                <div>
                <iframe  style="width:100%;height:500px" :src="this.url"  title="W3Schools Free Online Web Tutorials"></iframe>
                </div>

                     </v-col>

                  </v-row>
               </div>

      </v-container>
    </v-content>

  </v-app>

    </div>
  </div>
</template>

<script>
const ls = require('local-storage')
export default {
  data: () => ({
    url: ''
  }),
  created () {
    this.url = 'http://localhost:4001/print_html_pdf/' + ls.get('nomeUsuario') + ''
  }
}
</script>
